import NetworkImg from "@/assets/icons/web_Icons/network-svgrepo-com 1.svg";

const AuthDescription = () => {
  return (
    <div className="flex-col items-center justify-center flex-1 hidden gap-2 px-5 md:flex">
      <img src={NetworkImg} alt="" />
      <p className="font-bold">Enhanced Sign-in Security</p>
      <p className="text-xs max-w-[400px]">
        Using only a password to sign in? To strengthen the security of your
        account, we&apos;re introducing additional verification for any unusual
        sign-in attempts
      </p>
      <button className="flex items-center px-10 py-3 text-xs font-semibold transition-colors duration-300 rounded-full bg-[#DDEEFF] text-primary hover:bg-hover hover:text-white">
        LEARN MORE
      </button>
    </div>
  );
};

export default AuthDescription;
